<ion-app>
  <ion-router-outlet></ion-router-outlet>

  <div *ngIf="stage !== 'production'" class="stage">{{ stage }}</div>
</ion-app>
